import { StyleSheet } from "react-native";
export default StyleSheet.create({
  row: {
    flexDirection: "row",
    overflow: "hidden"
  },
  cols: {
    flexDirection: "row"
  },
  cell: {
    justifyContent: "center"
  },
  text: {
    backgroundColor: "transparent"
  }
});